module.exports = __webpack_public_path__ + "static/media/ChatbotLogo_NewHBT.3d778870.svg";